<template>
  <div
    :style="{
      height: drawerHeight
    }"
    class="z-50 absolute top-0 start-0 w-full bg-slate-200 dark:bg-slate-700"
  >
    <Transition name="fade" mode="out-in">
      <div v-if="globalStore.topbarState" class="w-full h-full">
        <button
          class="absolute top-2 end-2"
          @click="globalStore.$patch((state) => (state.topbarState = false))"
        >
          <faTimesIcon class="w-6" />
        </button>
        <slot></slot>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useGlobalStore } from '@/stores/global'
import faTimesIcon from '@/assets/icons/faTimes.svg?component'

const globalStore = useGlobalStore()

const drawerHeight = ref(0)

globalStore.$subscribe((mutation, { topbarState }) => {
  drawerHeight.value = topbarState ? '100vh' : 0

  document.body.style.overflow = globalStore.hasDrawer ? 'hidden' : 'inherit'
})
</script>

<style lang="scss" scoped></style>
